import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";

import {
  ExpandMore,
  Add,
  DeleteOutlineOutlined,
  EditOutlined,
} from "@material-ui/icons/";

import {
  BallContainer,
  HeaderAccordion,
  IconButtonStyled,
  TableContent,
  WarningLabel,
} from "../styles/Produto";

import TableDefault from "../../../../components/grid/TableDefault";
import { ProdutoContext } from "../contexts/ProdutoContext";
import useProdutoController from "../controllers/ProdutoController";
import Chip from "../../../../components/basics/Chip";
import ModalProdutoTabelaPreco from "./ModalProdutoTabelaPreco";
import RedBall from "../../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../../assets/imgs/bolinha-verde.png";
import MaskService from "./../../../../utils/mask/maskService";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";

export default function AccordionProdutoTabelaPreco() {
  const {
    priceTable,
    setPriceTable,

    expanded,
    errors,
  } = useContext(ProdutoContext);
  const {
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
  } = useProdutoController();
  const [open, setOpen] = useState(false);
  const [loadingTable] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        const actions = [
          {
            icon: <EditOutlined />,
            name: "Editar",
            action: () =>
              handleEditItemTable(setOpen, setRowEdit, item, item.index),
          },
          {
            icon: <DeleteOutlineOutlined />,
            name: "Deletar",
            action: () =>
              handleRemoveItemTable(
                setDataTable,
                setPriceTable,
                priceTable,
                item.index,
                item.id
              ),
          },
        ];

        return <SpeedDialErp actions={actions} />;
      },
    },
    {
      id: "descricao",
      label: "Tabela de Preço",
    },
    {
      id: "margem",
      label: "Margem",
      format: (item) => `
      ${item.margem}%`,
    },
    {
      id: "descontopadrao",
      label: "Desconto Padrão",
      format: ({ descontopadrao }) =>
        `R$ ${MaskService.toMask("decimal", descontopadrao)}`,
    },
    {
      id: "descontomaximopadrao",
      label: "Desconto Máximo",
      format: ({ descontomaximopadrao }) =>
        `R$ ${MaskService.toMask("decimal", descontomaximopadrao)}`,
    },
    {
      id: "comissaopadrao",
      label: "Comissão",
      format: ({ comissaopadrao }) =>
        `R$ ${MaskService.toMask("decimal", comissaopadrao)}`,
    },
    {
      id: "ativo",
      label: "Ativa",
      format: ({ ativo }) =>
        ativo === "S" ? (
          <BallContainer>
            <img src={GreenBall} alt="green-ball" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="red-ball" />
          </BallContainer>
        ),
    },
  ];

  useEffect(() => {
    setDataTable(
      priceTable.map((item, index) => ({
        ...item,
        index,
      }))
    );
  }, [priceTable]);

  return (
    <>
      {open && (
        <ModalProdutoTabelaPreco
          open={open}
          setOpen={setOpen}
          setRowEdit={setRowEdit}
          rowEdit={rowEdit}
          usedIds={priceTable.map((e) => e.id)}
        />
      )}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.tablePrice || false}
          onChange={() => handleChangeOpenAcordion("tablePrice")}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs>
                  <Chip
                    label="TABELAS DE PREÇOS"
                    error={!expanded.tablePrice && errors.accordionTablePrice}
                  />
                </Grid>

                <Grid item flex={1}>
                  <Tooltip title="Adicionar Local de Estoque">
                    <IconButtonStyled onClick={() => setOpen(true)}>
                      <Add />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        loading={loadingTable}
                        columns={columns}
                        values={dataTable}
                        tableTitle={
                          errors.accordionStockLocations ? (
                            <WarningLabel>
                              Informe ao menos um local de estoque
                            </WarningLabel>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
